var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('JbPointList',{ref:"list",attrs:{"biz-ctg":_vm.$config.BIZ_CATEGORY.ELEVATOR},on:{"link-edit":_vm.handleLinkEdit,"link-new":_vm.handleLinkNew}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }